export default __webpack_public_path__ + "static/media/cmp_logo.b9aa7744.jpeg";